import { useCookie } from 'react-use'
import { toUpper } from 'ramda'
import { object, func } from 'prop-types'

import { Typography, Link, Notification } from '@telus-uds/components-web'

// import localeContext from '../../../../contexts/Locale'
import useTranslate from '../../../../hooks/useTranslate'
import { getCartProvince, getCartLanguage } from '../util'

const ProvinceMisMatchNotification = ({ cart, resetCart }) => {
  const [, updateCookie] = useCookie('prov')
  const cartProvince = getCartProvince(cart)
  const cartLanguage = getCartLanguage(cart)
  const translate = useTranslate()
  // const { lang } = useContext(localeContext)

  const provinceName = translate(`provinces.${cartProvince}`)

  const switchBackToCartProvince = (event) => {
    event.preventDefault()
    updateCookie(toUpper(cartProvince), {
      domain: '.telus.com'
    })
    // eslint-disable-next-line no-undef
    window.location.reload(false)
  }

  const handleResetCartClick = async (event) => {
    event.preventDefault()
    await resetCart({
      language: cartLanguage
    })
  }

  return (
    <Notification
      variant={{ validation: 'error' }}
      testID="cart-province-mismatch-error-core-notification"
    >
      <Typography variant={{ size: 'medium' }} testID="cart-province-mismatch-error-notification">
        {translate('appNotification.provinceMismatchNotification.heading')}
        <Link
          href="#"
          onClick={switchBackToCartProvince}
          testID="cart-province-mismatch-error-switch-province-cta"
          variant={{ style: 'inline', size: 'small' }}
        >
          {translate('appNotification.provinceMismatchNotification.revertProvince.cta', {
            replacements: {
              province: provinceName
            }
          })}
        </Link>
        <Typography variant={{ size: 'medium' }}>
          {translate('appNotification.provinceMismatchNotification.conjunction')}
        </Typography>
        <Link
          href="#"
          onClick={handleResetCartClick}
          testID="cart-province-mismatch-error-reset-cart-cta"
          variant={{ style: 'inline', size: 'small' }}
        >
          {translate('appNotification.provinceMismatchNotification.removeItems.cta')}
        </Link>
        <Typography variant={{ size: 'medium' }}>
          {translate('appNotification.provinceMismatchNotification.startAgainSentence')}
        </Typography>
      </Typography>
    </Notification>
  )
}

ProvinceMisMatchNotification.propTypes = {
  cart: object.isRequired,
  resetCart: func.isRequired
}

export default ProvinceMisMatchNotification
